import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

const initGaleriaSwiper = () => {
  const el = document.querySelector('.galeria__swiper');
  if (!el) return;

  new Swiper(el, {
    modules: [Pagination, Navigation, Autoplay],
    loop: true,
    speed: 700,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: '.galeria__pagination',
      clickable: true,
    },
    navigation: {
      prevEl: '.galeria__nav-prev',
      nextEl: '.galeria__nav-next',
    },
  });
};

export const initFichaServicio = () => {
  initGaleriaSwiper();
};
